import styled from 'styled-components';
import { Column } from '@prisjakt/ui/list/variants';
import { layout } from 'src/components/base';

export const StyledNoResult = styled(Column)`
  text-align: left;
  padding: 0 ${layout.measurements.spacing050};
  margin: ${layout.measurements.spacing100} 0;
`;

export const StyledTitle = styled.p`
  margin: 0 ${layout.measurements.spacing050};
`;

export const StyledImage = styled.img`
  margin-left: ${layout.measurements.spacing050};
  padding-top: ${layout.measurements.spacing100};
  padding-bottom: ${layout.measurements.spacing150};
`;
